import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminDashboard from './pages/authorized/admin-dashboard';
import AdminLogin from './pages/unauthorized/admin-login';
import ServiceManagement from './pages/authorized/service-management';
import BusinessProfileSettings from './pages/authorized/business-profile-settings';
import StaffManagement from './pages/authorized/staff-management';
import { ToastContainer } from "react-toastify";
import BookingManagement from "pages/authorized/booking-management";
import CategoryManagement from "pages/authorized/category-management";
import AuthLanding from "pages/authorized";
import UnauthorizedLanding from "pages/unauthorized/UnauthorizedLanding";
import Home from "pages/unauthorized/landing";
import SubscriptionPlans from "pages/unauthorized/subscription-plans";
import ContactUs from "pages/unauthorized/contact-us";
import SignUp from "pages/unauthorized/sign-up";
import PasswordReset from "pages/unauthorized/password-reset";
import UserProfile from "pages/authorized/user-profile";
import Reporting from "pages/authorized/reporting";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          {/* <Route path="/" element={<AdminDashboard />} /> */}
          <Route element={<UnauthorizedLanding />}>
            <Route index path="/" element={<Home />} />
            <Route path="/subscription-plans" element={<SubscriptionPlans />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/account/password-reset" element={<PasswordReset />} />
          </Route>
          <Route element={<AuthLanding />}>
            <Route index path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/category-management" element={<CategoryManagement />} />
            <Route path="/service-management" element={<ServiceManagement />} />
            <Route path="/business-profile-settings" element={<BusinessProfileSettings />} />
            <Route path="/staff-management" element={<StaffManagement />} />
            <Route path="/booking-management" element={<BookingManagement />} />
            <Route path="/reporting" element={<Reporting />} />
            <Route path="/user-profile" element={<UserProfile />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        <ToastContainer/>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
